import Recall from "../../pages/snail/springFestivalActive/recall/index.vue";
import Light from "../../pages/snail/springFestivalActive/light/index";

const base = "springFestivalActive";

const routes = [
  {
    path: `/${base}Recall/enter*`,
    name: `${base}Recall-enter`,
    component: Recall
  },
  {
    path: `/${base}Light/enter*`,
    name: `${base}Light-enter`,
    component: Light
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/springFestivalActive.js